import SearchableMultipleSelectionInput, {
  SearchableMultipleSelectionInputProps,
  OptionSearchableMultipleSelectionProps,
} from './SearchableMultipleSelectionInput';

export type { SearchableMultipleSelectionInputProps, OptionSearchableMultipleSelectionProps };
export default SearchableMultipleSelectionInput;
